// api/categoriesApi.js
import { getCurrentUser } from '../components/utils/authService';

const API_BASE_URL = '/api';

export const fetchCategories = async () => {
  const user = getCurrentUser();
  try {
    const response = await fetch(
      `${API_BASE_URL}/users/${user.user_id}/categories`,
      {
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
      }
    );
    
    if (!response.ok) {
      throw new Error('Failed to fetch categories');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

export const createCategory = async (name) => {
  const user = getCurrentUser();
  try {
    const response = await fetch(
      `${API_BASE_URL}/users/${user.user_id}/categories`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ 
          name, 
          is_special: name === 'Main'
        })
      }
    );

    if (!response.ok) {
      throw new Error('Failed to create category');
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating category:', error);
    throw error;
  }
};

export const updateNoteCategoryAndSecondaries = async (noteId, newCategoryId, oldCategoryId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/notes/${noteId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        primary_category_id: newCategoryId,
        secondary_categories: JSON.stringify([])  // Reset secondary categories
      })
    });

    if (!response.ok) {
      throw new Error('Failed to update note category');
    }
  } catch (error) {
    console.error('Error updating note category:', error);
    throw error;
  }
};

export const deleteCategory = async (categoryId) => {
  const user = getCurrentUser();
  try {
    const response = await fetch(
      `${API_BASE_URL}/users/${user.user_id}/categories/${categoryId}`,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      }
    );

    if (!response.ok) {
      throw new Error('Failed to delete category');
    }
  } catch (error) {
    console.error('Error deleting category:', error);
    throw error;
  }
};